import { HideFlags } from "../Const";
import { Loader } from "../net/Loader";
export class WidgetPool {
    constructor() {
        this._count = 0;
        this._items = {};
    }
    clear() {
        for (let i in this._items) {
            let arr = this._items[i];
            arr.forEach(obj => obj.destroy());
        }
        this._items = {};
        this._count = 0;
    }
    get count() {
        return this._count;
    }
    get defaultRes() {
        return this._defaultRes;
    }
    set defaultRes(value) {
        this._defaultRes = value;
        if (value && !value.url)
            value.url = "data:" + idCounter++;
    }
    get defaultRuntime() {
        return this._defaultRuntime;
    }
    set defaultRuntime(value) {
        this._defaultRuntime = value;
        if (value)
            this._createOptions = { runtime: value };
        else
            this._createOptions = null;
    }
    take(url) {
        var _a;
        if (!url) {
            url = (_a = this._defaultRes) === null || _a === void 0 ? void 0 : _a.url;
            if (!url) {
                console.warn("set defaultRes first!");
                return null;
            }
        }
        let arr = this._items[url];
        if (arr && arr.length > 0) {
            this._count--;
            return arr.shift();
        }
        let ret;
        if (url.startsWith("data:"))
            ret = this._defaultRes.create(this._createOptions);
        else
            ret = Loader.getRes(url).create(this._createOptions);
        if (ret)
            ret.hideFlags |= HideFlags.HideAndDontSave;
        return ret;
    }
    recover(obj) {
        let url = obj.url;
        if (!url) {
            obj.destroy();
            return;
        }
        let arr = this._items[url];
        if (!arr) {
            arr = [];
            this._items[url] = arr;
        }
        this._count++;
        arr.push(obj);
    }
}
var idCounter = 0;
